import { render, staticRenderFns } from "./UserImage.vue?vue&type=template&id=ae3d2e6c&scoped=true"
import script from "./UserImage.vue?vue&type=script&lang=js"
export * from "./UserImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3d2e6c",
  null
  
)

export default component.exports